import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const frequencies = [
  { value: 174, name: "Pain Relief" },
  { value: 285, name: "Tissue Healing" },
  { value: 396, name: "Liberation" },
  { value: 417, name: "Transformation" },
  { value: 432, name: "Universal" },
  { value: 528, name: "Miracle Tone" },
  { value: 639, name: "Connection" },
  { value: 741, name: "Expression" },
  { value: 852, name: "Intuition" },
  { value: 963, name: "Divine" },
];

const FrequencySelector = ({ value, onChange, showCustom = true }) => {
  const [customValue, setCustomValue] = React.useState("");
  const [isCustom, setIsCustom] = React.useState(false);

  const handleCustomChange = (e) => {
    const val = e.target.value;
    setCustomValue(val);
    if (val && !isNaN(val)) {
      onChange(parseInt(val));
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {frequencies.map((freq) => (
          <motion.button
            key={freq.value}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => {
              setIsCustom(false);
              onChange(freq.value);
            }}
            data-testid={`freq-${freq.value}`}
            className={cn(
              "p-3 rounded-xl border transition-all duration-200 text-left",
              value === freq.value && !isCustom
                ? "border-violet-500 bg-violet-500/20 text-white"
                : "border-white/10 bg-white/5 text-gray-400 hover:border-white/20 hover:text-white"
            )}
          >
            <div className="font-mono text-sm font-medium">{freq.value} Hz</div>
            <div className="text-xs mt-0.5 opacity-70">{freq.name}</div>
          </motion.button>
        ))}
      </div>

      {showCustom && (
        <div className="flex items-center gap-3">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setIsCustom(true)}
            className={cn(
              "px-4 py-2 rounded-lg border text-sm transition-all duration-200",
              isCustom
                ? "border-cyan-500 bg-cyan-500/20 text-cyan-400"
                : "border-white/10 text-gray-400 hover:border-white/20"
            )}
          >
            Custom
          </motion.button>
          
          {isCustom && (
            <motion.div
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              className="flex items-center gap-2"
            >
              <input
                type="number"
                value={customValue}
                onChange={handleCustomChange}
                placeholder="Enter Hz"
                data-testid="custom-frequency-input"
                className="w-32 px-3 py-2 bg-black/20 border border-white/10 rounded-lg text-white placeholder:text-gray-600 focus:border-violet-500/50 focus:outline-none focus:ring-1 focus:ring-violet-500/50 font-mono"
              />
              <span className="text-gray-500">Hz</span>
            </motion.div>
          )}
        </div>
      )}
    </div>
  );
};

export default FrequencySelector;
